import React from "react";
import { Icon, IconProps } from "@chakra-ui/react";

const MessageIcon = (props: IconProps) => (
  <Icon viewBox="0 0 25 25" boxSize="18px" {...props}>
    <path
      d="M4.90625 4.65436H20.9062C21.3226 4.65436 21.6662 4.79712 21.9648 5.09576C22.1347 5.2656 22.2529 5.45024 22.3242 5.65436H4.40625V18.6544H21.4062V7.25201L20.6416 7.73053L12.9062 12.5645L5.40625 7.87701V7.05573L12.6416 11.5782L12.9062 11.7442L13.1709 11.5782L21.1709 6.57819L22.3721 5.82721C22.3939 5.93128 22.4062 6.03991 22.4062 6.15436V18.1544C22.4062 18.5707 22.2635 18.9143 21.9648 19.213C21.6662 19.5116 21.3226 19.6544 20.9062 19.6544H4.90625C4.48991 19.6544 4.1463 19.5116 3.84766 19.213C3.54901 18.9143 3.40625 18.5707 3.40625 18.1544V6.15436C3.40625 5.73802 3.54901 5.39441 3.84766 5.09576C4.1463 4.79712 4.48991 4.65436 4.90625 4.65436Z"
      fill="currentColor"
      stroke="currentColor"
    />
  </Icon>
);

export default MessageIcon;
